import { render } from "./QuienesSomos.vue?vue&type=template&id=93616b24&scoped=true"
import script from "./QuienesSomos.vue?vue&type=script&lang=js"
export * from "./QuienesSomos.vue?vue&type=script&lang=js"

import "./QuienesSomos.vue?vue&type=style&index=0&id=93616b24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93616b24"]])

export default __exports__